/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 *
 * site-constants
 * @flow
 */

// TODO: use package.json version instead of hard-code
const urlRoot = 'https://kepan.netlify.com';
const version = '1.0.0';
const babelURL = 'https://unpkg.com/babel-standalone@6.26.0/babel.min.js';
const TITLE_POSTFIX = ' - Kingspress';
const TITLE_PREFIX = 'Kingspress - ';

export {urlRoot, version, babelURL, TITLE_POSTFIX, TITLE_PREFIX};
